<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <div class="check-box">
              <label
                class="checkbox-s"
                v-for="(item, index) in contents"
                v-if="modalType === MODAL_TYPE.KEY_VALUE_LIST"
                :key="index"
              >
                <input
                  type="radio"
                  name="radio"
                  :checked="defaultValue ? index === 0 : false"
                  :value="item"
                  v-model="state.object"
                />
                <span class="check-txt">{{ item.value }}</span>
              </label>

              <label
                class="checkbox-s"
                v-for="(item, index) in contents"
                v-if="modalType === MODAL_TYPE.VALUE_LIST"
                :key="index"
              >
                <input type="radio" name="radio" :value="item" v-model="state.object" />
                <span class="check-txt">{{ item }}</span>
              </label>

              <label class="checkbox-s" v-for="(item, index) in contents" v-if="isEmpty(modalType)" :key="index">
                <input type="radio" name="radio" :value="item" v-model="state.object" />
                <span class="check-txt">{{ item.key }}</span>
              </label>
            </div>
          </div>
          <label
            class="label pd-side16"
            v-if="modalType === MODAL_TYPE.VALUE_LIST && state.object?.includes('직접입력')"
          >
            <!--pd-side16-->
            <input type="text" required placeholder="직접 입력" v-model="state.textInput" />
          </label>
          <BasicButton modal-btn @leftEvent="close" @rightEvent="fnFetch" left-text="닫기" right-text="선택" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { COMMENT_LIST, MODAL_TYPE } from '@/common/constants/ConstCode';
import { computed, onMounted, reactive } from 'vue';
import { isEmpty } from '@/common/utils/Util';

import { showTextModal } from '@/common/utils/ModalState';
import BasicButton from '@/components/common/layouts/BasicButton.vue';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, fnCancelCallBack, defaultValue, selectedValue, modalType, errorText, maxLength } = props.data;

const contents = computed(() => props.data?.contents);
const state = reactive({
  object: '',
  textInput: ''
});

onMounted(async () => {
  state.object = selectedValue?.key ? selectedValue : defaultValue;
});

const fnFetch = () => {
  if (maxLength && state.object.includes('직접입력')) {
    whenContainsTextInput();
  } else {
    fnSelect();
  }
};

const whenContainsTextInput = () => {
  if (state.textInput.length > maxLength) {
    showTextModal(errorText, '확인');
    return false;
  }

  if (isEmpty(state.textInput)) {
    showTextModal('누락된 정보를 입력해 주세요.', '확인');
    return false;
  }

  if (fnCallBack) fnCallBack(state.textInput);
  close();
};

const fnSelect = () => {
  if (fnCallBack) fnCallBack(state.object);
  close();
};

const close = () => {
  setTimeout(() => {
    emits('close');
    if (fnCancelCallBack) {
      fnCancelCallBack();
    }
  }, 300);
};
</script>
<style scoped></style>
